import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageManagerService } from 'src/app/services/storage-manager.service';
import { UiService } from 'src/app/services/ui.service';
import { fromEvent, Subject } from 'rxjs';
import { AppComponent } from '../../app.component';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

    destroy$ = new Subject<void>();

    constructor(
        private ui: UiService,
        private route: ActivatedRoute,
        private location: Location,
        storageManager: StorageManagerService,
        private app: AppComponent) {
        ui.stopLoading();
        storageManager.removeString('recommended-list');

        storageManager.setPage('home');
    }

    ngOnInit() {
        history.pushState(null, '', location.origin + '/home');
        fromEvent(window, 'popstate')
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                history.pushState(null, '', location.origin + '/home');
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
    }

    focusHero = () => {
        setTimeout(() => {
            document.getElementById('hero-banner-1').focus();
        }, 200);
        this.location.replaceState('home');
    };

}
